import React, { useState, useEffect, Fragment } from 'react'
import MultipleStepsForm from 'components/funnel/MultipleStepsForm'
import InformationForm from 'components/bookings/InformationForm'
import GiftRecipientForm from 'components/bookings/GiftRecipientForm'
import OrderPayment from 'components/bookings/OrderPayment'
import OrderCheckoutValidation from 'components/bookings/OrderCheckoutValidation'
import GiftOrderSuccess from 'components/bookings/GiftOrderSuccess'
import OrderSuccess from 'components/bookings/OrderSuccess'
import BookingFaqs from 'components/bookings/BookingFaqs'
import OrderRecap from 'components/bookings/OrderRecap'
import googleTracker from 'lib/trackers/googleTracker'
import lockIcon from 'images/icons/lock.svg'
import {
  shouldRenderOrderCheckoutValidation,
  isOrderPaid,
  isPaymentError
} from 'lib/Checkout'

const OrderCheckout = ({
  user: userProp,
  order: orderProp,
  authenticityToken,
  availableCountries,
  images,
  steps,
  urls,
  babaPhoneNumber
}) => {
  const [order, setOrder] = useState(orderProp)
  const [user, setUser] = useState(userProp)
  const [showPaymentForm, setShowPaymentForm] = useState(!isOrderPaid(order))

  useEffect(() => {
    if (order.orderStatus === 'in_creation') {
      googleTracker.trackInitiateCheckout(trackingInfo())
    } else if (
      order.orderStatus !== 'payment_error' &&
      order.orderStatus !== 'pre_auth_error'
    ) {
      googleTracker.trackPurchase(trackingInfo())
    }
  }, [])

  useEffect(() => {
    setShowPaymentForm(!isOrderPaid(order))
  }, [order])

  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://widgets.rr.skeepers.io/generated/e0619e69-b4b3-dd44-911b-45b8a77e037e/e36c503a-fa16-45d8-b180-be41115fd0e4.js'
    script.async = true
    document.body.appendChild(script)
  }, [])

  const trackingInfo = () => ({
    activityId: order.activity.id,
    activityName: order.activity.name,
    centerId: order.center.id,
    price: order.priceAfter,
    isGift: order.isGift ? 'is_gift' : 'is_booking',
    orderId: order.id,
    coupon: order.couponName
  })

  const handleOrderModification = (data) => {
    setOrder(data.order)
  }

  const stepsArray = []

  if (shouldRenderOrderCheckoutValidation(order)) {
    const validationForm = (
      <OrderCheckoutValidation
        urls={urls}
        order={order}
        onOrderModification={handleOrderModification}
        trackingInfo={trackingInfo()}
        previousStepURL={urls.activityURL}
      />
    )
    const optionStepName = order.isGift ? 'Options' : 'Option'
    stepsArray.push({
      name: optionStepName,
      content: validationForm,
      url: steps.validationURL
    })
  }

  const informationForm = (
    <InformationForm
      urls={urls}
      authenticityToken={authenticityToken}
      user={user}
      onUserModification={setUser}
      trackingInfo={trackingInfo()}
      priceAfter={order.priceAfter}
      onOrderModification={handleOrderModification}
      order={order}
      previousStepURL={
        shouldRenderOrderCheckoutValidation(order)
          ? undefined
          : urls.activityURL
      }
    />
  )
  stepsArray.push({
    name: 'Informations',
    content: informationForm,
    url: steps.informationURL
  })

  if (order.isGift) {
    const giftRecipientForm = (
      <GiftRecipientForm
        order={order}
        onOrderModification={handleOrderModification}
        updateGiftRecipientStepUrl={urls.giftRecipientStepUpdateURL}
        availableCountries={availableCountries}
      />
    )
    stepsArray.push({
      name: 'Personnalisation',
      content: giftRecipientForm,
      url: steps.giftRecipientURL
    })
  }

  if (showPaymentForm) {
    const paymentForm = (
      <div className="checkout-payment">
        <OrderPayment
          order={order}
          user={user}
          setOrder={setOrder}
          onOrderModification={handleOrderModification}
          urls={urls}
          trackingInfo={trackingInfo()}
          authenticityToken={authenticityToken}
        />
      </div>
    )
    stepsArray.push({
      name: 'Paiement',
      content: paymentForm,
      url: steps.paymentURL
    })
  } else {
    let successNode
    if (order.isGift) {
      successNode = <GiftOrderSuccess urls={urls} />
    } else {
      successNode = <OrderSuccess urls={urls} />
    }

    stepsArray.push({
      name: 'Paiement',
      content: successNode,
      url: steps.paymentURL
    })
  }

  let initialStep = 0
  if (isOrderPaid(order) || isPaymentError(order)) {
    initialStep = stepsArray.length - 1
  }
  const faqType = order.isGift ? 'gift_order' : 'order'

  return (
    <div className="container mb-3">
      <MultipleStepsForm
        images={images}
        initialStep={initialStep}
        steps={stepsArray}
        isOrderPaid={isOrderPaid(order)}
        homepageURL={urls.homepageURL}
        activityURL={urls.activityURL}>
        <Fragment>
          <OrderRecap order={order} />
          <div className="row secure-payment-banner text-center">
            <div className="col-xs-12">
              <img
                src={lockIcon}
                alt="Paiement sécurisé"
                className="mr-2"
                height={18}
                width={18}
              />
              <strong>Paiement 100% sécurisé</strong>
            </div>
          </div>
          <div className="col-xs-12">
            <div
              className="center-child-link"
              id="e36c503a-fa16-45d8-b180-be41115fd0e4"></div>
          </div>
        </Fragment>
      </MultipleStepsForm>
      <BookingFaqs type={faqType} babaPhoneNumber={babaPhoneNumber} />
    </div>
  )
}

OrderCheckout.displayName = 'OrderCheckout'
export default OrderCheckout
